<section id="hero-banner">
    <div class="container">
        <h1>Empowering Growth Through Technology</h1>
        <p class="hero-text">Powering success with trusted tech and tailored IT solutions</p>
    </div>
</section>

<section id="about-us">
    <div class="container1">
        <!-- <div class="row"> -->
        <div class="col-lg-12">
            <div class="about-intro">
                <h2>About Us</h2>
                <p class="section-description">We are a leading company in our industry, committed to providing
                    top-notch services to our clients.</p>
                <div class="about-us-container">
                    <div class="ceo-message col-lg-4">
                        <img src="assets/images/ceo_sachin.png" alt="ceo" class="about-ceo-image">
                    </div>
                    <div class="ceo-message col-lg-6">
                        <h2>CEO's Message</h2>
                        <div class="message-content">
                            <p>
                                In today’s dynamic technology landscape, what has driven Superior Digital forward over
                                the
                                past 10 years is our unwavering commitment to innovation, integrity, and
                                customer-centricity. Founded with the vision of being the one-stop destination for all
                                IT
                                solutions, we’ve grown by building strong partnerships, delivering reliable outcomes,
                                and
                                continuously evolving to meet the changing needs of our clients. As we look ahead to the
                                next chapter, our focus remains on expanding our capabilities, nurturing talent, and
                                creating exceptional value while staying true to our founding purpose and values.
                            </p>
                            <div class="ceo-signature">
                                <p>- Sachidananda K (Sachin)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="about-content">
                <div class="about-item">
                    <div class="icon">
                        <i class="fas fa-lightbulb" style="color: #078906;"></i>
                    </div>
                    <h3>Our Approach</h3>
                    <p>Superior Digital creates tailored IT solutions through in-depth consultations that identify each
                        client’s goals and challenges. Using the latest Apple, MDM, and advanced technologies, we build
                        scalable, reliable systems that evolve with emerging tech.</p>
                </div>

                <div class="about-item">
                    <div class="icon">
                        <i class="fas fa-star" style="color: #078906;"></i>
                    </div>
                    <h3>Superior Story</h3>
                    <p>Founded in 2015 by three innovators, Superior has grown into a 50+ member team, serving over 480+
                        enterprise clients with tailored IT solutions. With 40+ premium brand partnerships and 800+
                        satisfied customers, we continue to lead with trust, quality, and innovation.</p>
                    <!--  <p>Superior began its journey in 2013 with just three committed individuals driven by a passion for excellence and innovation. Through years of hard work and visionary leadership, the team has grown to over 100 skilled professionals, proudly serving more than 900 enterprise clients with tailored, high-quality solutions.</p>
                   <p>With strategic alliances forged with over 30 premium brands, Superior continues to expand its footprint in the industry. The trust and loyalty of over 1,000 satisfied customers stand as a testament to our unwavering dedication to service and success.</p> -->
                </div>

                <div class="about-item">
                    <div class="icon">
                        <i class="fas fa-eye" style="color: #078906;"></i>
                    </div>
                    <h3>Our Vision</h3>
                    <p> To be a pioneering force in our industry, driving innovation and excellence to exceed our
                        customers' expectations. We strive to cultivate a sustainable future, fostering a community of
                        growth, collaboration, and trust.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- </div> -->
</section>

<!-- <section id="our-vision">
    <div class="info-area pt-100 pb-70 bg-color">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-sm-6">
                    <div class="single-info">
                        <div class="info-img">
                            <img src="assets/images/info/i1.jpg" alt="info" />
                        </div>
    
                        <div class="content">
                            <h3><i class="flaticon-info"></i> About Us</h3>
                            <div class="arrow">
                                <a routerLink="/about"><i class="flaticon-next-1"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="col-lg-4 col-sm-6">
                    <div class="single-info">
                        <div class="info-img">
                            <img src="assets/images/info/i2.jpg" alt="info" />
                        </div>
    
                        <div class="content">
                            <h3><i class="flaticon-support"></i> Our Vision</h3>
                            <div class="arrow">
                                <a routerLink="/about"> <i class="flaticon-next-1"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-4 col-sm-6 offset-sm-3 offset-lg-0">
                    <div class="single-info si-30">
                        <div class="info-img">
                            <img src="assets/images/info/i3.jpg" alt="info" />
                        </div>
    
                        <div class="content">
                            <h3><i class="flaticon-goal"></i>Our Goal</h3>
                            <div class="arrow">
                                <a routerLink="/about"><i class="flaticon-next-1"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<section class="statistics-area pt-100 pb-100">
    <div class="container">
        <div class="row align-items-center class1">
            <div class="col-lg-3 col-md-12">
                <div class="single-statistics">
                    <h1 class="statistics-text">{{displayedValues[0]}}</h1>
                    <p>{{statistics[0].text}}</p>
                    <!-- <p>{{statistics[0].subtext}}</p> -->
                </div>
            </div>
            <div class="col-lg-9 col-md-12">
                <div class="row class2">
                    <div class="col-sm-6 col-md-3" *ngFor="let stat of statistics.slice(1); let i = index">
                        <div class="single-statistics">
                            <h3>{{displayedValues[i + 1]}}{{stat.prefix}}</h3>
                            <p>{{stat.text}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="enterprise" class="enterprise-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="enterprise-content">
                    <h2>Enterprise</h2>
                    <p class="enterprise-text">
                        We provide customised end to end technology solutions for businesses. Having served over 480+ customers and partnering up with the world's leading technology innovators, we have the unrivalled depth of expertise to help you win.
                    </p>
                    <div class="enterprise-actions">
                        <a href="/superior-enterprise" class="know-more-btn">Know More</a>
                        <!-- <div class="enterprise-arrow">
                            <i class="fas fa-arrow-right"></i>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="blog-section pt-100 pb-100">
    <div class="container">
        <div class="section-title text-center mb-5">
            <h2>Latest Insights</h2>
            <p>Stay updated with our latest news and developments</p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="blog-card">
                    <div class="blog-img">
                        <img src="assets/images/blog/1.jpg" alt="Software Development">
                    </div>
                    <div class="blog-content">
                        <div class="blog-meta">
                            <span>15 April 2025</span>
                        </div>
                        <h3>Free MacBook Health Check at MNC</h3>
                        <p>Superior Digital conducted a free Apple MacBook diagnostic session at a leading corporation.</p>
                        <a href="/activity" class="read-more">Read More →</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="blog-card">
                    <div class="blog-img">
                        <img src="assets/images/blog/5.jpg" alt="UX Design">
                    </div>
                    <div class="blog-content">
                        <div class="blog-meta">
                            <span>20 April 2025</span>
                        </div>
                        <h3>Team Collaboration Workshop</h3>
                        <p>Sales and Pre-Sales teams aligned to enhance delivery and collaboration.</p>
                        <a href="/activity" class="read-more">Read More →</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="blog-card">
                    <div class="blog-img">
                        <img src="assets/images/blog/3.jpg" alt="Enterprise Solutions">
                    </div>
                    <div class="blog-content">
                        <div class="blog-meta">
                            <span>25 April 2025</span>
                        </div>
                        <h3>Optimizing Apple Ecosystems</h3>
                        <p>Strategies shared to deliver seamless Apple device and MDM deployment.</p>
                        <a href="/activity" class="read-more">Read More →</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center mt-4">
            <a href="/activity" class="view-all">View All Articles</a>
        </div>
    </div>
</section> -->

<section class="life-at-superior pt-100 pb-100">
    <div class="container">
        <div class="section-title">
            <span style="font-size: 18px; font-weight: bold; color: #e43a35;">Life at Superior</span>
            <h2>Experience a Culture of Innovation and Excellence</h2>
            <p>At Superior, we foster an environment where creativity and collaboration thrive. Join us to be part of a
                team that values growth, learning, and making a difference.</p>
        </div>

        <div class="row mobilegap">
            <div class="col-lg-4 col-md-6">
                <div class="single-life">
                    <div class="life-img">
                        <img src="assets/images/innovative_workspace.png" alt="life at superior">
                    </div>
                    <br>
                    <div class="content">
                        <h3 style="font-size: 20px;">Innovative Workspaces</h3>
                        <p style="font-size: 16px;">Our workspaces are designed to inspire creativity and collaboration, providing the perfect
                            environment for innovation.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-life">
                    <div class="life-img">
                        <img src="assets/images/team_building_new.png" alt="life at superior">
                    </div>
                    <br>
                    <div class="content">
                        <h3 style="font-size: 20px;">Team Building Activities</h3>
                        <p style="font-size: 16px;">We believe in the power of teamwork. Our regular team-building activities help strengthen
                            bonds and foster a sense of community.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                <div class="single-life">
                    <div class="life-img">
                        <img src="assets/images/continuous_learning_new.png" alt="life at superior">
                    </div>
                    <br>
                    <div class="content">
                        <h3 style="font-size: 20px;">Continuous Learning</h3>
                        <p style="font-size: 16px;">At Superior, learning never stops. We offer various programs and workshops to help our team
                            members grow and excel in their careers.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="home-contact-area bg-color ptb-100" id="contact-us">
    <div class="container">
        <div class="section-title">
            <span>Contact Us</span>
            <h2>Let Us Know About Your Project Idea!</h2>
            
        </div>

        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="contact-img">
                    <img src="assets/images/contact-img.png" alt="contact">
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="content">
                    <form id="contactForm" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                        <div class="row">
                            <div class="col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <input type="text" formControlName="name" class="form-control" required placeholder="Your Name" />
                                </div>
                            </div>

                            <div class="col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <input type="email" formControlName="email" class="form-control" required placeholder="Your Email" />
                                </div>
                            </div>

                            <div class="col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <input type="text" formControlName="phone" class="form-control" required placeholder="Your Phone" />
                                </div>
                            </div>

                            <div class="col-lg-12 col-sm-12" style="margin-bottom: 20px;">
                                <div class="form-group">
                                    <select formControlName="device" class="form-control">
                                        <option value="" disabled selected>Select Device</option>
                                        <option *ngFor="let device of devices" [value]="device">{{ device }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <textarea formControlName="message" class="form-control" rows="5" required placeholder="Your Message"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <button type="submit" class="box-btn">Send Message</button>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="message" class="alert" [ngClass]="{'alert-success': message.includes('successfully'), 'alert-danger': message.includes('Error')}">
                            {{ message }}
                        </div>
                    </form>
                </div>
            </div>
          
        </div>
    </div>
</section> -->